module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("1")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("Grover Cleveland: The Mysterious Case of the Disappearing President")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Albany, New York")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("July 21, 1884")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Governor Grover Cleveland stared in disbelief at the front page of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Buffalo Telegraph")]), _vm._v(". Just ten days earlier he had received the Democratic Party’s nomination for president, and given his reputation for unwavering honesty, he knew that he had a real chance to win. His Republican opponent, the notoriously corrupt James G. Blaine—a man who would soon become known as “Blaine, Blaine, James G. Blaine, the Continental liar from the state of Maine!”—was vulnerable. If Cleveland managed to parlay his sterling reputation into a victory in November, he would be the first Democrat elected since before the Civil War.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now, as Cleveland stared in disgust at the newspaper sitting on his desk, victory looked a lot less likely. A T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERRIBLE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALE")]), _vm._v(", screamed the morning’s headline. A D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARK")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAPTER IN A")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UBLIC")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISTORY")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Telegraph")]), _vm._v("’s article told the story of Maria Halpin, a widow in Cleveland’s hometown of Buffalo, who had a child named Oscar Folsom Cleveland.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("Cleveland, a bachelor, had never acknowledged that his former lover’s child was his. After all, several of his drinking buddies had also shared Maria’s bed—could he really be sure of his paternity? But those friends were all married, so Cleveland had agreed to give the child his last name and his financial support. When the boy was sent to an orphanage after Maria’s excessive drinking and deteriorating emotional state led to her stay in a mental institution, Cleveland had dutifully paid the orphanage bill of five dollars a week.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, in the midst of Cleveland’s presidential campaign, the nine-year-old child’s very existence threatened to derail his White House hopes—unless he could find a way to turn this crisis into an opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Cleveland read through the article, much of which was exaggerated and sensationalized, the governor began to formulate a strategy. The American people, he reasoned, would forgive a sexual indiscretion. In fact, if he was completely honest about something so embarrassing—something so many men lied about almost out of habit—voters might actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("reward")]), _vm._v(" him. His candor would reinforce the trustworthiness that had been his calling card ever since he’d been elected to replace Buffalo’s corrupt mayor in 1881 and New York’s corrupt governor in 1882. Now, in a meteoric rise to national prominence, that same forthrightness would save his nomination for president of the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Write this down, and send it to all my friends in Buffalo,” Cleveland ordered his press secretary and close confidant, Daniel Lamont. “I have a simple message for anyone who is asking anything about Maria Halpin.” His voice now boomed with confidence and authority. “Whatever you do . . . tell the truth!”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cleveland’s strategy worked perfectly. By the narrowest of margins, and, in large part thanks to the trust inspired by his response to the Maria Halpin scandal, the governor of New York was elected president of the United States of America. Joseph Pulitzer, of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York World,")]), _vm._v(" spoke for millions when he explained the four reasons he supported Grover Cleveland: “1. He is an honest man; 2. He is an honest man; 3. He is an honest man; 4. He is an honest man.”")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Nine Years Later")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("From Washington, D.C., to New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("July 1, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The president grimaced as he climbed into the presidential carriage for the trip down Pennsylvania Avenue to the Baltimore & Potomac train station. It took quite an effort for the six-foot, one-inch, three-hundred-pound chief executive to get from the ground to his seat. Even though Grover Cleveland was more than strong enough, the fifty-six-year-old didn’t enjoy physical exertion. He’d once told Daniel Lamont, who was now serving as secretary of war, that even walking was an annoyance to be avoided whenever possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lamont was at Cleveland’s side for the ride to the train station, just as he had been for the better part of the last decade. The president thought of his friend, who was fourteen years younger, as the son he’d never had. Lamont even looked in some ways like a slightly thinner and balder version of Cleveland, right down to the bushy walrus mustache they both sported. Unfailingly loyal, Lamont and Cleveland shared an affinity for whiskey, cigars, hunting, and fishing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lamont was by Cleveland’s side when he won the presidential election in 1884, and he was there when Cleveland lost the White House in 1888, despite having won the popular vote. Four years later, Lamont reprised his role as press secretary in Cleveland’s bid to reclaim the presidency. They celebrated together in 1892 when Cleveland defeated Benjamin Harrison by a landslide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his second term Cleveland promoted his friend to secretary of war, but the president continued to rely on Lamont’s judgment and counsel in all critical matters of state. First among those matters was the “money question.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Silver Purchase Act of 1890 required the United States Treasury to purchase 4.5 million ounces of silver each month and to print large amounts of paper currency that could be redeemed for that silver. The consequence was inflation—wild, catastrophic, panic-inducing inflation. By Cleveland’s inauguration in March, the United States was in the midst of the worst economic recession in its history: the aptly labeled Panic of 1893.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Cleveland and Lamont arrived at the train station and boarded a special car prepared for them by the railroad’s owner. The president placed a supremely high value on discretion. Once aboard, his first priority was to order a cigar and a whiskey. His second order of business was to pull down the window shades. A private man even under ordinary circumstances, Cleveland knew the purpose of this trip was anything but ordinary. The press and public were on a “need to know” basis, and as far as he was concerned, there was nothing about this journey that any of them needed to know.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland had frequently received good press, especially as it related to his anticorruption efforts as mayor, governor, and president, yet he still despised reporters. As the train left the station, he recalled all the times journalists had poked their noses in where they didn’t belong, beginning with their coverage of the Maria Halpin affair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At times, Cleveland’s rage at reporters turned to fits of anger. At other times, he found an outlet for his frustration by writing blistering letters to newspaper editors. To one publication, he wrote that “the falsehoods daily spread before the people in our newspapers are insults to the American love for decency and fair play of which we boast.” To another, he blasted “keyhole correspondents” for using “the enormous power of the modern newspaper to perpetuate and disseminate a colossal impertinence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whiskey soon arrived, as did the cigar. With all the shades pulled down, Cleveland was able to relax for the first time since he’d hoisted himself into the presidential carriage. Only after he and Lamont were safely away from the Washington, D.C., area did Cleveland raise the shades to enjoy the views as the New York Express chugged northward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sights outside the president’s window, however, were not always pleasing to his eye. Occasionally the train would pass by shantytowns filled with jobless vagabonds and homeless families making the most of what tin, cardboard, and spare lumber they could find to create shelter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("The train was moving fast, but he could still see the misery in the sunken eyes of the unfortunate inhabitants. Cleveland knew that unemployment was at an all-time high, that stocks were anemic, that banks, railroads, and factories were failing, that farm foreclosures were rampant, and that all the wrong rates were rising: interest rates, ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("unemployment rates, and, if the papers were to be believed, suicide rates as well. Even so, Cleveland was not prepared for the wretched, impoverished conditions he saw from his window. The shantytowns looked like refugee camps in some third-world, war-ravaged country.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The tragic sights of suffering steeled the president’s resolve to repeal the Silver Purchase Act. Just that morning, before surreptitiously leaving the capital, he had called for a special session of Congress to consider repealing the law he blamed for the country’s woes. He was sure he could persuade them to eliminate the act. He was coming off a landslide election and the political momentum was squarely on his side. Only public disclosure of the purpose of the trip he was now on could stop him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland arrived in Jersey City, New Jersey, and boarded a ferry for Manhattan. His destination was a luxurious yacht anchored in the East River, which would then sail him to his vacation home in Massachusetts, on Buzzards Bay, off Cape Cod. Before he could get there, however, he had to deal with a handful of reporters who had discovered that the president was no longer at the White House. They were curious to know why he had left Washington on the eve of debate over the Silver Purchase Act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have nothing to say for publication, except that I am going to Buzzards Bay for a rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("July 1, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("Early Evening")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Among the reporters who had been on the ferry with Grover Cleveland was Elisha Jay Edwards, known to readers of his almost daily column by his one-word penname: Holland.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("With a thick, light brown mustache that did little to obscure his handsome, angular face, Edwards was among the most diligent and respected journalists in the nation. A skilled researcher and writer, he had graduated from Yale Law School in 1873 and then stayed in New Haven to practice law. Those plans changed when he purchased an ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("interest in New Haven’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Elm City Press")]), _vm._v(". Before long, his photographic memory, penchant for dogged investigations, and ability to write quickly, clearly, and elegantly made him the best reporter in that Connecticut city.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The early 1870s were the beginning of a drastic, two-decade media expansion. New printing technologies and a rise in literacy were the driving forces behind a threefold increase in newspaper sales. During that era, no publisher was as respected and feared as the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Sun")]), _vm._v("’s Charles Dana. It was Dana who plucked the talented Edwards out of obscurity and brought him from New Haven to New York in 1879.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After ten years of twelve-hour days with Dana, Edwards took a job as the New York correspondent for the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Philadelphia Press")]), _vm._v(". It was there that “Holland” became one of the most read syndicated columnists in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Six days a week, in newsrooms across the nation, reporters would begin their day by asking the same question: “What does Holland say today?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the evening sun set outside his window in the Schermerhorn Building on Manhattan’s Lower East Side, Edwards wrote out the next day’s column in longhand. It included a bit of gossip about Interior Secretary Hoke Smith, “the only member of the cabinet who has dared to assert himself in the presence of the president,” and a little news about “a delegation of starving miners” who “may be sent to Washington from Colorado and Montana demanding from President Cleveland not bread but silver, which is the same to them.” Finally, near the end of the column, was a note about how President Cleveland and his friend Elias Benedict were planning to spend much of July together at their vacation homes on Buzzards Bay. “Mr. Benedict says that Mr. Cleveland is as impatient for the sea bass fishing and as hungry for a day’s sport trolling for bluefish as a schoolboy is for the first day of his vacation.”")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("On Board the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("East River, New York City")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("July 2, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("10:30 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("As the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" pulled anchor on a warm, sunny morning and set sail northward, the president of the United States smiled and relaxed comfortably on her deck. He always felt his best when surrounded by old friends, and he had plenty of them now lounging beside him: his friend Elias Benedict, Lamont, and Joseph Bryant, who was his brother-in-law, family doctor, and frequent fishing companion. Over the years, Cleveland had traveled more than fifty thousand miles on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(", often with some combination of these three men at his side and a fishing pole in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland’s affinity for the boat was understandable, perhaps even unavoidable. With two masts and a glistening white 144-foot hull, she was a sleek, spectacularly gorgeous yacht. In 1885, the vessel—then named the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Utowana")]), _vm._v("—won the prestigious Lunberg Cup race. Soon after that, Elias Benedict purchased it and rechristened her "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The president chatted amiably with his friends about matters large and small while the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" glided past dozens of other boats in the East River. Their destination, Buzzards Bay, was no secret, and a typical trip would take about fifteen hours. But Cleveland and his friends were all too aware that this was no ordinary journey. The expected departures from their usual route, as well as what would happen on that route, were known only to a handful of people—including the four gentlemen currently lounging on the ship’s deck, as well as a small number of passengers who had been hidden belowdecks, out of sight from the utterly unsuspecting public and press corps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shortly before noon, Cleveland watched as Joseph Bryant rose from his deck chair and walked toward the steps leading belowdecks. “If you hit a rock,” Bryant called to the captain, “hit it good and hard, so that we’ll all go to the bottom!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland was not amused.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("On Board the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("July 2, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("12:05 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("One of the small, tastefully decorated rooms belowdecks was a saloon. Grover Cleveland walked into it and stood in the middle of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A socially active ladies’ man back in his Buffalo days, Cleveland had been in hundreds of saloons over the course of his fifty-six years. But there were at least two unusual, even bizarre, aspects about the appearance of this particular one and the man who now stood in it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first was that the saloon had been stripped of all but one piece of furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second was that the three-hundred-pound president of the United States was standing nearly naked, wearing only his underwear and walrus mustache.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am ready for you,” said the commander in chief. “Are you ready for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("July 3, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Elisha Jay Edward was midway through the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" and all but done with his cup of tea when he noticed it.")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("O")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGN OF THE")])]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NEIDA")])]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESIDENT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AS")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OT")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ET")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RRIVED AT")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAY")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("The dispatch was buried in the middle of a tall column, below other short reports about a shooting at a boardinghouse and a political quarrel between an Irish-American organization and the mayor of Newark, New Jersey.")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Buzzards Bay, Mass.—The weather is thick in Buzzards Bay, and there are no signs of the yacht")]), _vm._v(" Oneida, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("having on board the Presidential party. Nothing has been heard of the party since they left New York.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The report’s last paragraphs noted that the “usual run” from Manhattan to Buzzards Bay was “fifteen hours,” and it stated that “inasmuch as the boat has not been reported at any of the ports, it is the opinion here that the yacht is at anchor down the bay awaiting the clearing of the fog, which will allow her to proceed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the breezy tone of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Times")]), _vm._v(" report, one fact was unavoidable: The president was missing.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("July 4, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("E. J. Edwards’s curiosity was further aroused when he arrived at the Schermerhorn Building on Independence Day and learned from the morning papers that President Cleveland was still unaccounted for. It had been three days since the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" slipped through the narrow channel between Manhattan and Queens, and no one on dry land had heard from the president since.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dressed in a dark suit, necktie, high-collared shirt, and high-topped leather shoes, Edwards continued to skim the morning papers and noticed that the more sensational of them were speculating that Cleveland was somehow in trouble. There were rumors of a serious illness, although Edwards thought that to be unlikely, as it would be cause for a return to shore, not a reason to remain at sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edwards knew that if Cleveland were gravely ill, it would spell doom for the repeal of the Silver Purchase Act. Foisted on Cleveland’s ticket for political balance at the Democratic convention, Vice President Adlai Stevenson was a staunch silverite. If fence-sitting congressmen sensed that Stevenson would soon be assuming power, they wouldn’t dare cross him and his pro-silver allies.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Edwards believed there was little sense in dwelling on such far-fetched possibilities. Newspapers could speculate as much as they wished ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("about the president’s seventy-two-hour absence, but Edwards thought Cleveland’s disappearance didn’t seem out of character. The president was famous for his desire for privacy, and he wasn’t the kind of man who needed much of a reason for keeping his whereabouts a secret.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The possibility of a serious illness seemed especially unlikely to Edwards for one additional reason: On the ferry to New York, Cleveland had said that he was merely “going to Buzzards Bay for a rest.” He had assured reporters there was nothing out of the ordinary about the trip. And, as everyone knew, Grover Cleveland was nothing if not honest.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("Morning, July 7, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Six days after Cleveland had set sail from Manhattan, E. J. Edwards was finally beginning to have doubts about the president’s story. The morning papers reported two pieces of intriguing news.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first concerned the president’s reemergence. Yesterday morning, the eight reporters awaiting his arrival at Gray Gables on Buzzards Bay had learned that Cleveland, Lamont, and Bryant had reached land in the middle of the night and slipped into Gray Gables without informing a single member of the press. When reporters pressed Lamont for an explanation of the president’s arrival—four days late and seemingly clandestinely choreographed—Lamont assured them the trip was “leisurely,” the party had “found good fishing grounds,” and that Cleveland’s health was “excellent, excepting that he was suffering from a slight attack of rheumatism.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The second news item detailed the transcript of an interview with Dr. Bryant conducted the previous evening by an unidentified reporter for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("United Press")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("United Press:")]), _vm._v(" Doctor, a number of conflicting stories are told concerning the illness of the president. Some of them make the matter very serious. You would confer a great favor by making some sort of official statement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Bryant:")]), _vm._v(" The president is all right.")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  })]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("United Press: From what is he suffering?")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Bryant:")]), _vm._v(" He is suffering from rheumatism, just as was reported this afternoon. Those reports were correct.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("United Press:")]), _vm._v(" Then, Doctor, the report that he is suffering from a malignant or cancerous growth in the mouth and that an operation was necessary and had been performed to relieve it is not correct?")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Bryant:")]), _vm._v(" He is suffering from the teeth; that is all.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("United Press:")]), _vm._v(" Has an operation been performed?")]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Bryant:")]), _vm._v(" That is all.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Gray Gables, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("July 7, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("7:15 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Bryant’s failure to unequivocally deny that an operation had been performed led to a feeding frenzy in the press. In an effort to alleviate the growing suspicions, the doctor quickly assembled the reporters. “The president is absolutely free from cancer or malignant growth of any description,” he told them. “No operation has been performed, except that a bad tooth was extracted.” Bryant categorically denied that any interview with a United Press reporter had taken place the night before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it was too late. By midafternoon, the number of reporters staying at Walker’s Hotel near Buzzards Bay had swelled from eight to fifty. Each of them was demanding answers to the question of what exactly the president of the United States had been doing for four unexplained days at sea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Secretary of War Lamont entered a large barn on the Gray Gables grounds, he felt an enormous sense of responsibility. Assembled there were the fifty reporters he had asked to gather for a 7:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")]), _vm._v(" press conference that was intended to answer their questions once and for all.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Lamont had been willing to reprise his role as Cleveland’s press secretary, not because he relished a return to the lion’s den, but because he believed no one else was up to the task. If he could convince reporters that the president’s health problems were nothing worse than ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("rheumatism and a toothache, Cleveland would retain the public’s confidence. More important, he would still be able to pressure Congress into repealing the Silver Purchase Act. On the other hand, if the reporters did not leave the barn satisfied that the rumors of cancer surgery were false, Cleveland’s reputation, and his political capital, would be gone.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(", cancer was an “incurable” disease. If politicians in Washington believed Cleveland’s life was in jeopardy, then his plans to revive the abominable economy would be as well. More banks would collapse; more farms would be foreclosed on; and millions more Americans would lose their jobs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a brief statement to make,” Lamont began, doing his best to affect a confident and casual air. “There has been quite a stir over a trivial occurrence of rheumatism. I think the reactions to the president’s minor aches and pains have been rather foolish, but I understand how unfounded rumors tend to take on a life of their own.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As reporters scribbled Lamont’s words into their notebooks, the secretary of war continued. “It was nothing but dentistry that occasioned President Cleveland’s journey on his friend Elias Benedict’s yacht. The president had been too busy attending to affairs of state in Washington to see a dentist, and he used the occasion of his boat trip from New York to Buzzards Bay to have some dental work performed in a comfortable environment. President Cleveland understands the public’s curiosity about his health, and he is grateful for their concerns about his well-being.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a hot and stuffy July evening, and sweat poured from the brows of the journalists packed into the barn. Lamont, on the other hand, looked as cool as a cucumber. There was no hesitation in his words or doubt in his tone. “President Cleveland’s dentist performed admirably, as did the patient, who has spent a relaxing day playing checkers with the First Lady.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Having swatted away the “unfounded rumors,” Lamont turned to the silverites who Cleveland blamed for the country’s economic woes. “The only dishonorable behavior in the past week,” he said coolly, with the slightest of smiles, “has come from quarters opposed to the president’s attempts to revive the American economy. The opposition ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("knows that the public stands firmly behind President Cleveland’s monetary policies, and their attempt to portray the president as ill or injured is a sign of their desperation.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For the next half hour, Lamont fielded questions asking for details about the dental procedures performed and the identity of the dentist employed, but time and again, Lamont dismissed the questions as “trivial” and “unworthy of a response.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was, in fact, only one question Lamont answered directly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is it true,” asked a correspondent from the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Tribune")]), _vm._v(", “that Vice President Stevenson left the World’s Fair in Chicago yesterday and is travelling to Buzzards Bay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Lamont answered emphatically. “Although, the Vice President did apparently make the mistake of believing some of the more sensational reports of the president’s health in your newspapers. It’s true he "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("did")]), _vm._v(" leave Chicago yesterday, and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("was")]), _vm._v(" heading here out of concern for the president’s health, but President Cleveland telegraphed him en route, reassured him of his general fitness, and requested Mr. Stevenson embark on a tour of the West Coast. There are important party leaders out there, and the administration desires that they know they have our respect and attention. For the next month, Vice President Stevenson will be visiting San Diego, San Francisco, Seattle, and cities in between.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Lamont returned to the main residence at Gray Gables he telegraphed the secretary of state to reassure him of the information he had just shared with the press. “To Walter Q. Gresham, Secretary of State,” Lamont wrote: “The president is laid up with rheumatism in his knee and foot, but will be out in a day or two. No occasion for any uneasiness. —D.S. Lamont.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As his last official act of the evening, Lamont instructed an assistant to send a copy of the telegram to the reporters staying at Walker’s Hotel. He was unsure how much of his story in the barn they believed, but he figured it couldn’t hurt to show them the same information was being sent to President Cleveland’s own secretary of state. Even if reporters believed Cleveland would allow Dan Lamont to mislead a group of reporters, surely they wouldn’t believe Cleveland would allow Lamont to lie to his own secretary of state.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("July 8, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("As the morning sun streaked through his window in the Schermerhorn Building, E. J. Edwards leaned back in his desk chair, puffed on his pipe, and skimmed the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Tribune.")])]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEVELAND")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ETTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IKELY TO")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ECOVER IN A")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York Times")]), _vm._v(" agreed:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The assertion that President Cleveland is afflicted with any malady is all nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Most ardent in its defense of the president’s good health was the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("New York World")]), _vm._v("’s editorial page.")]), _vm._v(" "), _c('p', {
    staticClass: "blockfb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The persistent attempts to misrepresent and exaggerate President Cleveland’s ailment are something more than scandalous at this time. If these reports were believed by the public, they might very easily, and probably would, precipitate a financial panic.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In a lecturing tone, the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("World")]), _vm._v(" went on to call it “a pity if a president cannot have a ‘touch of rhoumatix’ and a toothache without giving rise to a swarm of rumors and false reports—some of them more malignant than his disease.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edwards closed the paper and took a sip of his coffee. Like the rest of the country, he had been perplexed by the president’s disappearance. After reading the United Press’s interview with Dr. Bryant the morning before, he began to wonder whether there was some truth to the rumors about Cleveland’s ill health. However, the press corps covering the president seemed to believe what Lamont had told them. Now, in light of the morning papers’ consensus about the president’s medical condition, Edwards suspected that little more would be heard regarding the rumors.")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("Greenwich, Connecticut")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("August 27, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It had been nearly two months since E. J. Edwards had given much thought to President Cleveland’s mysterious disappearance. In that time, he had taken a summer vacation and then returned to Greenwich, Connecticut, where he kept a home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Edwards rode down the sweltering streets he heard a voice calling, “Edwards! Edwards!” The reporter instructed his driver to stop the carriage and then he poked his head out the window. Outside, he saw his friend Leander Jones running toward him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jones was a local doctor, and although Edwards wasn’t surprised that his friend would want to say hello and catch up, he was taken aback when, upon arriving at Edwards’s carriage, Jones, half out of breath, asked “Can you have your driver pull to the side? I have incredible news to share!”")]), _vm._v(" "), _c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("August 28, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("8:45 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In the late nineteenth century, the elegant brownstones of Harlem were among the most prestigious addresses on the continent. Inside their tony walls lived the leading men of New York City: doctors and lawyers, bank owners and industrialists, and a dentist named Ferdinand Hasbrouck, who happened to be among the nation’s leading experts in anesthesia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("E. J. Edwards rang the doorbell of Ferdinand Hasbrouck’s town house so early that the dentist was still in his nightshirt when he opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I apologize if you were sleeping, Dr. Hasbrouck,” the journalist said, extending his hand. “The name’s E. J. Edwards.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The two shook hands as Edwards continued: “I write for the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Philadelphia Press,")]), _vm._v(" and it’s only because I’m on a deadline that I’m here so ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("early. Would you mind taking a few moments to confirm a couple facts for an article I’m working on?”")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Edwards was somewhat surprised when Hasbrouck invited him in, excused himself to change out of his nightclothes, and returned with a polite and pleasant demeanor. The reporter wasn’t sure why Hasbrouck had received him, but he tried his best to hide how thrilled he was to be sitting in the parlor of a man who might have the answer to the biggest mystery in the history of the presidency: What had Grover Cleveland really been doing for four days on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I happened to be returning home in Greenwich yesterday,” said Edwards, “when a friend shared some details about your assistance with the president’s surgery on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" last month.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edwards was doing his best to make his information seem unimportant—as if he were just nailing down some details for a story that everyone already knew about. The truth, of course, was exactly the opposite: Dr. Hasbrouck might be able to provide first-person confirmation for the biggest scoop by any reporter of E. J. Edwards’s generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Edwards told Hasbrouck what he’d heard the day before, the dentist’s face grew ashen. His eyes widened with Edwards’s every word, and after just a few minutes, he flung himself back in his chair and sank down into it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, after Edwards described what happened on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" in exacting detail, Hasbrouck exclaimed, “Some of the physicians who were aboard the yacht must have told you that story! You could not have obtained it any other way!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, the first person from the ship to speak with E. J. Edwards was Ferdinand Hasbrouck. His time on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" had caused him to miss an appointment to provide anesthesia for a July 3 surgery in Greenwich with a doctor named Carlos MacDonald. In an attempt to explain his absence and protect his reputation against charges of unreliability, Hasbrouck revealed to MacDonald exactly where he had been on the first three days of July and exactly what he had been doing. MacDonald then told enough friends and colleagues that rumors about Cleveland’s health swirled around New York social circles well before the president ever reached Buzzards Bay.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Among those MacDonald told was a Connecticut doctor named Leander Jones.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "left1"
  }, [_vm._v("New York City")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("August 28, 1893")]), _vm._v(" "), _c('p', {
    staticClass: "leftb"
  }, [_vm._v("6:45 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“I’m calling with the biggest scoop you’ve ever heard in your life!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("E. J. Edwards spoke quickly into the phone to a stenographer for the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Philadelphia Press")]), _vm._v(". “It’s too big for me telegraph it to you, so I’m going to dictate everything I’ve written over the phone. Are you ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The real question, Edwards believed, was whether the country was ready.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Make seven headlines. The top one should say:")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESIDENT A")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERY")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICK")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AN")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Then, below it:")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PERATION")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERFORMED ON")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IM ON")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R")]), _vm._v(". B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENEDICT’S")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART OF THE")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AW")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EMOVED")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISEASE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOSE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YMPTOMS")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AVE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDICATIONS THAT")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IGHT")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARCOMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Follow that with:")]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("R")]), _vm._v(". C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEVELAND’S")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RESENT")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONDITION")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UCH AS TO")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVE")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCOURAGEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OT")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NLIKE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANT’S")])])])]), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Finally:")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "blockb"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AYS IN")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ED")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FTER THE")]), _vm._v(" U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SE OF")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AS AND")]), _vm._v(" K"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIFE—")]), _vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EVERAL OF")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EW")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORK’S")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XPERT")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HYSICIANS")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONCERNED”")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Edwards’s voice was full of excitement. For decades, he had tracked down every lead, cultivated countless sources, and had taken care to write one of the most reliably accurate and eloquent columns in the country. Now he was ready to inform the nation that their president had recently been diagnosed with cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland, Edwards would report, had assembled a dream team of doctors on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" to surgically remove his malignant tumor in an environment that would be free of leaks to the press. He had enlisted his friends—in particular his secretary of war—to cover it up with lies, all in the service of a president twice elected by the American people on the basis of his reputation for unwavering honesty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Edwards continued dictating into the phone. “Mr. Cleveland, with Mr. Lamont, whose faithful attendance . . . approaches that of filial affection and has been a matter of much comment during the summer, left Washington quite suddenly upon the day when the call for the extraordinary session of Congress was issued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Arrangements were made in this city with celerity, and Mr. Cleveland was met when he arrived here by Dr. Bryant and another physician, and by Dr. Hasbrouck, all of whom boarded the yacht with him. The baggage of these physicians contained the instruments of surgery and the apparatus for anesthetic administration.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Grover Cleveland had presented himself, per doctor’s orders, in his underwear, Edwards reported, the saloon he stood in had been converted into an operating room. Its only piece of furniture was a reclining chair for him to sit on during the surgery. Oxygen and nitrous oxide were stored in tanks beside it. Before him was his friend Joseph Bryant, along with three other surgeons, plus the White House physician, and Dr. Ferdinand Hasbrouck, who would administer anesthesia and pull the teeth blocking the tumor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“When the time came, the President of the United States submitted ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("himself to the surgeon as calmly, as gently, and as willingly as though he were merely lying down for brief slumber,” Edwards told the stenographer. “The operation did not require very long, but it entailed the cutting away of a considerable part of the upper jaw bone upon one side, the instrument boring through the bone and tissue as far as the orbital plate.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("After the operation—which caused Cleveland’s heart rate to fall and his temperature to surge—the president was left with a two-and-a-half-square-inch hole in his mouth where five teeth, a third of the roof of his mouth, and a considerable chunk of his upper jawbone had once been.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Faced with the most deceptive and audacious disappearing act in presidential history, Edwards took care not to exaggerate any aspect of the story. If anything, he felt he downplayed the peril the president was in. After all, only about 5 percent of patients who underwent surgery to remove a cancerous tumor survived for more than three years. In other words, the odds were only one in twenty that Grover Cleveland would serve the remainder of this presidential term.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nevertheless, Edwards assured readers that, although the president was “perhaps a very sick man,” his doctors expected him to recover. “Mr. Cleveland recovered from the shock even better than the physicians had dared to hope he would. He was kept in bed, so well treated that he slept much of the time, and after four days’ absence, during which time the country was wondering where he was, it was deemed safe to permit him to land at Gray Gables.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, Edwards did not need to exaggerate anything in his exposé. The truth was incredible enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was so incredible, in fact, that a strange thing happened after it was reprinted in newspapers from coast to coast over the next few days: The public didn’t believe it. The nation simply wasn’t willing to take E. J. Edwards’s word over their president’s.")])]), _c('p', {
    staticClass: "lefta"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("EPILOGUE")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("On the president’s behalf, his allies in the press waged a vigorous onslaught on Edwards’s veracity. The reporter was labeled a “panic-monger,” “a disgrace to journalism,” and a “calamity liar” whose reporting was “the very depth of despicable journalism.” Not a single person with firsthand knowledge of the president’s surgery went on record to confirm Edwards’s story and vindicate the maligned journalist. Edwards could have boosted his own credibility by revealing Hasbrouck’s name—or even the dentist’s connection to the surgery—but to protect his confidential source, Edwards refused to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Edwards endured attack after attack from Democratic-leaning newspapers like the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Philadelphia Times")]), _vm._v(". Its front-page story the day after the exposé was published was typical:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The only element of truth in the latest story of President Cleveland’s illness which has been printed in Philadelphia is that he suffered from a toothache and that the teeth which pained him were removed on board E. C. Benedict’s yacht.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockib"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Mr. Edwards surrounded his report of that event with all the cruel and cold-blooded details, true and false, which his imagination could call up.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The article added that Cleveland’s tooth extraction was “one of the commonest, simplest operations known to dentistry” and that “there was no question of cancer or of sarcoma. Any comparison between Mr. Cleveland’s toothache and the serious malady from which General Grant suffered and which caused his death was only another evidence of the exquisite heartlessness of the newspaper correspondent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without hesitation or exception, Cleveland, Lamont, and their allies tenaciously held on to their “toothache” story, and when the dust settled in the wake of Edwards’s article, the American people believed that, from July 1 to July 5, 1893, President Cleveland had gone fishing, suffered from some rheumatism, and had a few teeth extracted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("On the back of Cleveland’s popularity, and after one of the longest Senate filibusters in American history, Congress repealed the Silver ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Purchase Act on October 30, 1893. The president’s gambit to protect his political capital had worked—and the result was a radically new economic policy for the United States.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks to Cleveland’s deception, silver was out and gold was in, where it would remain until 1933, when the gold standard was abandoned by another former governor of New York, a Democratic president who shared with Cleveland a talent for covering up medical conditions: Franklin Delano Roosevelt.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although he never regained all his energy or weight—or, unfortunately for the White House staff, control over his temper—the president served out every remaining day of his term in office. In a stroke of immense luck, Cleveland’s cancer turned out to be unusually slow growing. When he died in 1908 (there is some debate about whether the cancer caused his death), not a single obituary mentioned his disappearance in July 1893 or the radical surgery his doctors performed in the saloon of the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not only did the president physically and politically survive the surgery—his tumor survived as well. Retained by one of his doctors as a souvenir, the clump of bone, tissue, and teeth today sits at the bottom of a glass jar on display in the New York Academy of Medicine’s Mutter Museum. The caption beside it reads, “Tumor—Specimen Removed from the maxillary (upper) left jaw of President Grover Cleveland on July 1st, 1893.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In light of all the misreporting and obfuscation about the president’s time on the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida,")]), _vm._v(" there is something fitting about the caption at the Mutter Museum: The date is wrong and the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("cancer")]), _vm._v(" is not mentioned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps the only thing that did not survive this bizarre episode of history intact was E. J. Edwards’s once sterling reputation. Although he would continue to write his column and investigate with tenacity and success, his readers and peers were unwilling to place the trust in “Holland” they’d once had. Cleveland had salvaged his political strength and his economic agenda only by slandering and irreparably injuring a blameless reporter who dared to expose the truth.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("It was not until 1917—nearly twenty-five years later—that one of the ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("surviving doctors from the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oneida")]), _vm._v(" operation admitted publicly that Edwards’s story “was substantially correct, even in most of the details.” In a lengthy article in the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Saturday Evening Post,")]), _vm._v(" Dr. William Keen, the most prestigious surgeon in the country, explained in intricate detail how he assisted Dr. Bryant and the other doctors who had operated on Grover Cleveland.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It had taken more than two decades, but in E. J. Edwards’s seventieth year, his readers finally learned once and for all that he was an honest man—and that Grover Cleveland was not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cleveland was, of course, hardly the last president to lie to the American people or engage in a nonstop war against transparency. Nor was he the last to have his word held in high esteem by a compliant press corps. What has changed in modern times, however, is that the media—the so-called fourth estate made up of America’s best and brightest journalists—are no longer trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sadly, that leaves the American people with no one to rely on: not the politicians; not the media.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nature may abhor a vacuum, but political systems abhor a vacuum of trust even more. If we don’t find someone to fill it—someone who can unify the country behind the truth—then that vacuum will be filled for us.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0